import { alpha, colors, darken } from '@mui/material';
export function playComponents(theme) {
    return {
        MuiButton: {
            defaultProps: {
                disableFocusRipple: true,
                disableElevation: true,
                fullWidth: false,
            },
            styleOverrides: {
                root: {
                    borderRadius: '40px'
                },
            },
            variants: [
                {
                    props: {
                        variant: 'outlined',
                    },
                    style: {
                        '&.Mui-disabled': {
                            color: alpha(theme.palette.primary.dark, 0.5),
                            borderColor: alpha(theme.palette.primary.dark, 0.5),
                        },
                    }
                },
                {
                    props: {
                        variant: 'text',
                    },
                    style: {
                        color: theme.palette.text.primary,
                        whiteSpace: 'nowrap',
                        lineHeight: 1,
                        padding: '0 0',
                        minWidth: 0,
                        '& .MuiSvgIcon-root': {
                            width: '1rem',
                            height: '1rem',
                        }
                    }
                },
                {
                    props: {
                        variant: 'primary-action',
                    },
                    style: {
                        textTransform: 'uppercase',
                        border: `1px solid ${theme.palette.primary.light}`,
                        backgroundColor: theme.palette.primary.main,
                        color: colors.teal[900],
                        '&:hover': {
                            border: `1px solid ${theme.palette.primary.main}`,
                            backgroundColor: theme.palette.primary.light,
                        },
                        '& .MuiSvgIcon-root': {
                            pointerEvents: 'none'
                        },
                        '&.MuiButtonBase-root.MuiButton-root.MuiButton-sizeLarge': {
                            fontSize: '0.8125rem',
                            padding: '0.5rem 1.75rem',
                            '& .MuiSvgIcon-fontSizeMedium': {
                                width: '2rem',
                                height: '2rem',
                            }
                        }
                    },
                },
                {
                    props: { variant: 'secondary-action' },
                    style: {
                        textTransform: 'uppercase',
                        backgroundColor: theme.palette.grey[900],
                        color: theme.palette.primary.main,
                        '& .MuiSvgIcon-root': {
                            pointerEvents: 'none',
                        },
                        '&:hover': {
                            color: theme.palette.primary.light,
                            backgroundColor: darken(theme.palette.primary.main, 0.6),
                        },
                        '&.Mui-disabled': {
                            color: theme.palette.grey[400],
                            backgroundColor: theme.palette.grey[500],
                        },
                        '&.MuiButton-sizeMedium': {
                            fontSize: '0.8125rem',
                            padding: '0.5rem',
                            minWidth: 0,
                            '& .MuiSvgIcon-fontSizeMedium': {
                                width: '2rem',
                                height: '2rem',
                            }
                        },
                        '&.MuiButton-sizeSmall': {
                            fontSize: '0.5625rem',
                            padding: '0.5rem',
                            minWidth: 0,
                            '& .MuiSvgIcon-fontSizeMedium': {
                                width: '1.25rem',
                                height: '1.25rem',
                            }
                        }
                    },
                },
            ]
        },
    };
}
//# sourceMappingURL=components.js.map